export enum SIGNUP_SOURCE {
    UNKNOWN = 0,
    SHOP = 1,
    CHECKOUT = 2,
    CLUB = 3,
    FILE = 4,
    OFFICE = 4,
}
